function EyeIcon() {
      return (
            <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="64"
                  height="64"
                  fill="none"
                  viewBox="0 0 64 64"
            >
                  <path
                        stroke="#292D32"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M41.547 32A9.537 9.537 0 0132 41.547 9.537 9.537 0 0122.453 32 9.537 9.537 0 0132 22.453 9.537 9.537 0 0141.547 32z"
                  ></path>
                  <path
                        stroke="#292D32"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M32 54.053c9.413 0 18.186-5.546 24.293-15.146 2.4-3.76 2.4-10.08 0-13.84C50.186 15.467 41.413 9.92 32 9.92c-9.414 0-18.187 5.547-24.294 15.147-2.4 3.76-2.4 10.08 0 13.84 6.107 9.6 14.88 15.146 24.294 15.146z"
                  ></path>
            </svg>
      );
}

export default EyeIcon;
